import { ref, Ref, computed, ComputedRef } from 'vue';
import { getParam } from '@utiles/index';
import { useStore } from 'vuex';

type CharInfoProps = {
  roleId: Ref<string>;
  serverId: Ref<string>;
  roleName: Ref<string>;
  gameId?: ComputedRef<string>;
  loginAccount?: ComputedRef<string>;
};

export default function useCharInfo(): CharInfoProps {
  const { state } = useStore();
  const roleId = ref('');
  const serverId = ref('');
  const roleName = ref('');
  const gameId = computed(() => state.gameId);
  const loginAccount = computed(() => getParam('loginAccount') || state.loginAccount || '');

  roleId.value =
    getParam('roleId') || getParam('role_id') || getParam('roleID') || '';
  serverId.value =
    getParam('serverId') || getParam('server_id') || getParam('serverID') || '';
  roleName.value = getParam('roleName') || getParam('role_name') || '';

  return {
    roleId,
    serverId,
    roleName,
    gameId,
    loginAccount,
  };
}
